import React from "react";

const GtmToolFormSection = () => {
  return (
    <section id="contact" className="contact section bg-section">
      {/* Section Title */}
      <div className="container section-title"></div>

      <div className="container ">
        <h1 className="display-5 mt-5 mb-70">
          <b>
            See Your GTM Truth in <span>60 Seconds.</span>
          </b>
        </h1>

        <div className="row g-5">
          {/* Left Content */}
          <div className="col-lg-6">
            <div className="content">
              <p className="lead mb-4 text-left">
                <b>
                  Your GTM data is talking, Most teams aren’t hearing it. This
                  quick check shows you what’s actually driving revenue and what’s
                  quietly blocking it.
                </b>
              </p>

              <p className="lead text-left">
                <b>In just 60 Seconds, uncover :</b>
              </p>

              <ul className="lead feature-benefits text-left">
                <li>
                  ● Which accounts show real buying intent
                </li>
                <li>
                  ● Where GTM signals are misaligned
                </li>
                <li>
                  ● Revenue risks hiding in plain sight
                </li>
                <li>
                  ● Opportunities your team isn’t activating
                </li>
              </ul>
            </div>
          </div>

          {/* Right Form */}
          <div className="col-lg-6">
            <div className="contact-form card">
              <div className="card-body p-4 p-lg-5">
                <h5 className="mb-4 text-center">
                  Fill in your details to unlock the tool.
                </h5>

                <form
                  action="https://api.web3forms.com/submit"
                  method="POST"
                  id="contact_form"
                >
                  <input
                    type="hidden"
                    name="redirect"
                    value="https://proplusdata.co/thank-you-gtm"
                  />
                  <input
                    type="hidden"
                    name="access_key"
                    value="9df4c372-c813-4806-97bb-685a8358a058"
                  />

                  <div className="row gy-4">
                    <div className="col-12">
                      <input
                        type="text"
                        name="Name"
                        className="form-control"
                        placeholder="Name"
                        required
                      />
                    </div>

                    <div className="col-12">
                      <input
                        type="email"
                        name="email"
                        className="form-control"
                        placeholder="Email ID"
                        required
                      />
                    </div>

                    <div className="col-12">
                      <button
                        type="submit"
                        className="btn btn-submit w-100"
                      >
                        Begin Assessment
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GtmToolFormSection;